import SavedNoHeart from "./saved-no-heart.png";
import SavedOneHeart from "./saved-one-heart.png";
import SavedTwoHeart from "./saved-two-heart.png";

import Chevrolet from "./brand-logos/logo-chevrolet.png";
import Ford from "./brand-logos/logo-ford.png";
import Gmc from "./brand-logos/logo-gmc.png";
import Honda from "./brand-logos/logo-honda.png";
import Hyundai from "./brand-logos/logo-hyundai.png";
import Jeep from "./brand-logos/logo-jeep.png";
import Kia from "./brand-logos/logo-kia.png";
import Mitsubishi from "./brand-logos/logo-mitsubishi.png";
import Nissan from "./brand-logos/logo-nissan.png";
import Ram from "./brand-logos/logo-ram.png";
import Subaru from "./brand-logos/logo-subaru.png";
import Toyota from "./brand-logos/logo-toyota.png";

import CarPlusShield from "./car-shield.png";

export {
  SavedNoHeart,
  SavedOneHeart,
  SavedTwoHeart,
  Chevrolet,
  Ford,
  Gmc,
  Honda,
  Hyundai,
  Jeep,
  Kia,
  Mitsubishi,
  Nissan,
  Ram,
  Subaru,
  Toyota,
  CarPlusShield,
};
